import RequestTypes from "./RequestTypes";
/**
 * Analytics
 */
var Analytics = /** @class */ (function () {
    function Analytics(config) {
        this.adapter = config.adapter;
    }
    Analytics.prototype.getAdapter = function () {
        return this.adapter;
    };
    /**
     * Who is the visitor?
     * @param id
     * @param traits
     */
    Analytics.prototype.identity = function (id, traits) {
        var request = {
            identity: {
                id: id,
            },
            traits: traits,
            type: RequestTypes.Identity,
        };
        return this.record(request);
    };
    /**
     * What are they doing?
     * @param event
     * @param properties
     */
    Analytics.prototype.track = function (event, category, properties, isUserInteraction) {
        if (isUserInteraction === void 0) { isUserInteraction = true; }
        var request = {
            category: category,
            event: event,
            isUserInteraction: isUserInteraction,
            properties: properties,
            type: RequestTypes.Track,
        };
        return this.record(request);
    };
    /**
     * What environment are they in?
     * @param key
     * @param value
     */
    Analytics.prototype.set = function (key, value) {
        var request = {
            properties: {
                key: key,
                value: value,
            },
            type: RequestTypes.Set,
        };
        return this.record(request);
    };
    /**
     * What webpage are they on?
     * @param name
     * @param properties
     */
    Analytics.prototype.page = function (name, properties) {
        var request = {
            page: {
                name: name,
            },
            properties: properties,
            type: RequestTypes.Page,
        };
        return this.record(request);
    };
    /**
     * What account or organization are they part of?
     * @param name
     * @param properties
     */
    Analytics.prototype.group = function (name, properties) {
        var request = {
            group: {
                name: name,
            },
            properties: properties,
            type: RequestTypes.Group,
        };
        return this.record(request);
    };
    /**
     * What was their past identity?
     * @param id
     */
    Analytics.prototype.alias = function (id) {
        var request = {
            identity: {
                id: id,
            },
            type: RequestTypes.Alias,
        };
        return this.record(request);
    };
    /**
     * This function will append data to the analytics request,
     * before it is being recorded through the adapter.
     * @param request
     */
    Analytics.prototype.record = function (request) {
        return this.adapter.record(request);
    };
    return Analytics;
}());
export default Analytics;
//# sourceMappingURL=Analytics.js.map